// extracted by mini-css-extract-plugin
export default {"popOver":"ProdutoVendidoAdd_popOver__HsUuq","listContainer":"ProdutoVendidoAdd_listContainer__sUHMJ","modal":"ProdutoVendidoAdd_modal__qA9a1"};